import './App.scss';
import { useEffect } from 'react';
import { Analytics } from '@vercel/analytics/react';

import Nav        from './components/Nav';
import Hero       from './components/Hero';
import Experience from './components/Experience';
import Projects   from './components/Projects';
import Education  from './components/Education';
import About      from './components/About';
import Contact    from './components/Contact';
import Footer     from './components/Footer';

function App() {
  // Scroll-reveal via IntersectionObserver. Content is visible by default
  // (see .reveal in App.scss); we only arm the hidden→visible animation
  // when IntersectionObserver is actually available, so a slow/failed
  // observer never leaves content stuck invisible.
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return;

    const els = document.querySelectorAll('.reveal');
    els.forEach((el) => el.classList.add('armed'));

    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('on'); }),
      { threshold: 0.06 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <Nav />

      <div className="page">
        <Hero />
        <div className="divider" />
        <Experience />
        <div className="divider" />
        <Projects />
        <div className="divider" />
        <Education />
        <div className="divider" />
        <About />
        <div className="divider" />
        <Contact />
      </div>

      <Footer />
      <Analytics />
    </>
  );
}

export default App;
